import $670gB$react from "react";
function fixedForwardRef(render) {
  return $670gB$react.forwardRef(render);
}
export {
  fixedForwardRef
};
